<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-3">
        <div class="side-heading">
          <h6>{{ $t('contactDashboard.contactUs') }}</h6>
          <p class="font13 gray-col mb-0">
            {{ $t('contactDashboard.subtitle') }}
          </p>
        </div>
      </div>
      <div class="card-details-def contact-spe-card">
        <contactComp :loader="loader" :logo="logo" :email="email" :phone="phone" :socials="socials"  />
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import contactComp from "../components/dashboard/contactComp.vue";
import axios from "axios";
import { onMounted, ref } from "vue";

// reactive state
const loader = ref(false);
const logo = ref("");
const email = ref("");
const phone = ref("");
const socials = ref([]);

// functions
function getContact() {
  loader.value = true;
  axios
    .get("/socials", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      logo.value = response.data.data.logo;
      email.value = response.data.data.email;
      phone.value = response.data.data.phone;
      socials.value = response.data.data.socials;
      loader.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  getContact();
});
</script>
